<template>
  <div id="app">
    <router-view/>
    <emailReply/>
  </div>
</template>

<script>
import emailReply from '@/views/component/emailReply/index.vue'
export default {
  name: 'App',
  components: {
    emailReply
  }
}

</script>
